import { useState, useRef } from 'react';

const ImageZoomHover = ({src,className}) => {
    const [isHovering, setIsHovering] = useState(false);
    const containerRef = useRef(null);
    const imageRef = useRef(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    
    // Configuration options
    const zoomLevel = 2;  // Higher value = stronger zoom
   
    
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      
      const { left, top, width, height } = containerRef.current.getBoundingClientRect();
      
      // Calculate cursor position as percentage of container dimensions
      const x = Math.max(0, Math.min(100, ((e.clientX - left) / width) * 100));
      const y = Math.max(0, Math.min(100, ((e.clientY - top) / height) * 100));
      
      setPosition({ x, y });
    };
  return (
      
    <div 
    ref={containerRef}
    className="relative overflow-hidden  w-full h-full cursor-crosshair"
    onMouseEnter={() => setIsHovering(true)}
    onMouseLeave={() => setIsHovering(false)}
    onMouseMove={handleMouseMove}
  >
    {/* Original image */}
    <img
      ref={imageRef}
      src={src}
      alt="Original image"
      className={className}
      style={{
        transformOrigin: `${position.x}% ${position.y}%`,
        transform: isHovering ? `scale(${zoomLevel})` : 'scale(1)',
        transition: 'transform 0.05s ease-out'
      }}
    />
    </div>
      
     
  );
};

export default ImageZoomHover;